import { theme } from "@/constants/theme";
import { useEffect, useLayoutEffect } from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";

const defaultOptions = {
  chart: {
    height: 250,
    type: "radialBar",
    animations: {
      enabled: true,
      animations: {
        enabled: true,
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
    },
  },
  series: [70],
  labels: [""],
  colors: [theme.primary],
  plotOptions: {
    radialBar: {
      hollow: {
        margin: 0,
        size: "70%",
      },
      track: {
        dropShadow: {
          enabled: true,
          top: 2,
          left: 0,
          blur: 4,
          opacity: 0.15,
        },
      },
      dataLabels: {
        name: {
          color: theme.secondary,
          show: false,
        },
        value: {
          fontWeight: "bold",
          fontSize: "30px",
          color: theme.secondary,
        },
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      gradientToColors: [theme.secondary],
      stops: [0, 100],
    },
  },
  stroke: {
    lineCap: "round",
  },
};

function RadialProgressChart({
  id = "radial-progress-chart",
  options = {},
  series,
  height,
}) {
  const chartOptions = {
    ...defaultOptions,
    ...options,
    chart: {
      id,
      ...defaultOptions.chart,
      ...options.chart,
    },
    plotOptions: {
      ...defaultOptions.plotOptions,
      ...options.plotOptions,
    },
  };

  useEffect(() => {
    ApexCharts.exec(id, "updateOptions", [series]);
  }, [id, series]);

  return (
    <Chart
      options={chartOptions}
      type={defaultOptions.chart.type}
      series={series}
      height={height || defaultOptions.chart.height}
    />
  );
}

export default RadialProgressChart;
